<template>
  <div class="schedule-tracker">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'ScheduleTracker',
  provide() {
    return {
      scheduleTracker: this
    }
  },
  data() {
    return {
      registeredTrackerItems: []
    }
  },
  methods: {
    registerTrackerItem(item) {
      if(!this.registeredTrackerItems.find(i => i === item)) {
        this.registeredTrackerItems.push(item)
        item.$once('hook:destroyed', () => {
          this.unregisterTrackerItem(item)
        })
      }
    },
    unregisterTrackerItem(item) {
      this.registeredTrackerItems = this.registeredTrackerItems.slice().filter(i => i !== item)
    },
    isPrevItemCompleted(item) {
      var itemIndex = this.registeredTrackerItems.findIndex(i => i == item)
      if(itemIndex > 0)
        return this.registeredTrackerItems[itemIndex-1].$props.completed
      return false
    },
    isLastItem(item) {
      return this.registeredTrackerItems.findIndex(i => i == item) == this.registeredTrackerItems.length - 1
    }
  }
}
</script>